export const ProductShow = require("./ProductShow").default;
export const Checkout = require("./Checkout").default;
export const History = require("./History").default;
export const Favorite = require("./Favorite").default;
export const FABandBackdrop = require("./FABandBackdrop").default;
export const PaypalCheckout = require("./PaypalPay").default;
